import axios from 'axios'

export default {
  // API:08
  async getServices() {
    return await axios.get(`users/mypage_ninal_contracts`)
  },
  // API:09
  async getService(id) {
    return await axios.get(`users/mypage_ninal_contracts/${id}`)
  },
  /* 退会できる状態かどうかの確認 */
  async getCanWithdraw() {
    return await axios.get(`users/withdrawal_check`)
  },
  /* 退会処理 */
  async postWithdraw() {
    return await axios.post(`users/withdrawal`)
  },
  async getProducts(contractId, purchase_detail_ids, signal = undefined) {
    return await axios.get(`users/mypage_ninal_contracts/${contractId}/get_purchase_details`, {
      params: {
        purchase_detail_ids,
      },
    })
  },
}
